import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import DocumentsListApp, { DocumentsListAppProps } from "../documents/documents";
import { ResourceAppProps } from "./resource";
import { RessVisa } from "./ressVisaInGrid";
import React from "react";

export default class RessSchulInGrid extends React.Component<ResourceAppProps, {
    gridData: RessSchul[]
}>{
    private gridOptions = {};
    editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        };
        this.gridOptions = this.props.context.ressSchulInGridOptions;
    }

    componentDidMount() {
        this.bindToSaveSuccessfully();
        this.loadData();
    }

    private bindToSaveSuccessfully = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.loadData();
        });
    }

    private loadData = async () => {
        let url = "Resource/GetGridSchulData?id=" + encodeURIComponent(this.props.entity.Ressnr);
        const result = await HTTPService.get<JsonResultClass<RessSchul[]>>(url)
        if (result.Code == 0) {
            this.props.entity.RessSchulsLoaded = true;
            this.setState({ gridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private createNewEntity = (): RessSchul => {
        let entity: RessSchul = {
            IsGuid: kendo.guid(),
            Datum1: new Date(),
            IsNew: true
        }
        return entity;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    private handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem: RessSchul = this.createNewEntity();
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
        }
    }

    private onDataChange = (action, fieldName, dataItems) => {
        if (action == "itemchange" && dataItems.length == 1) {
            const item: any = dataItems[0];
            switch (fieldName) {
                case "Datum1":                    
                    break;
                case "Datum2":
                case "Gueltigkeit":                   
                    if (Helper.hasValue(item.Gueltigkeit) && item.Gueltigkeit > 0) {
                        const end = item.Datum2.getTime()
                        const newExpiry = end + (item.Gueltigkeit * 24 * 60 * 60 * 1000)
                        item.set('Expiry', new Date(newExpiry));
                    } else if (item.Gueltigkeit == 0) {
                        item.set('Expiry', null);
                    }
                    const data = this.state.gridData;
                    const index = data.findIndex(f => f.IsGuid == item.IsGuid);
                    if (index > -1) {
                        data[index] = item;
                        this.setState({ gridData: data })
                    }
                    break;
                default:
                    break;
            }

        }


        this.props.context.setEntityDirtyState(true)
    }

    render() {
        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "IsGuid";
        schema.fields["IsGuid"] = new field("string");
        return <EditableGrid data={this.state.gridData}
            id="ressSchulInGrid"
            schema={schema}
            gridOptions={this.gridOptions}
            ref={(ref) => this.editableGridRef = ref}
            editable={this.props.entity.RecordRight.CanWrite}
            onDataChanged={this.onDataChange}
            buttons={buttons}
            onButtonClick={this.handleButtonClick}
            {...this.props} helpEditUrl={this.props.helpUrl}
        />
    }
}

export interface RessSchul {
    Datum2?: Date;
    Schulung?: string;
    Stunden?: number;
    Gueltigkeit?: number;
    Expiry?: Date;
    Bemerkung?: string;
    Premonition?: number;
    Noreminder?: boolean;
    Email?: string;
    Ressnr?: string;
    Datum1?: Date;
    IsGuid?: string;
    IsNew?: boolean;
}